export const borderWidth = {
  kilo: '1px',
  mega: '2px',
  giga: '3px',
};
